var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.Ct=require("ttag");module.exports=$CLJS.Ct;